<portal-main-nav>
  @if (showEnterpriseSwitcher) {
    <portal-enterprise-switcher></portal-enterprise-switcher>
  }

  <portal-main-nav-item [showPopover]="isActive.site" icon="far fa-cog" route="enterprise-settings">
    <span>{{ 'menu.settings' | portalTranslate }}</span>

    <ng-template>
      <portal-enterprise-settings-sub-nav [force]="true"></portal-enterprise-settings-sub-nav>
    </ng-template>
  </portal-main-nav-item>

  <portal-main-nav-item
    *portalIsAuthorized="{
      anyPermission: [Permission.VIEW_USER, Permission.MANAGE_USER],
    }"
    [showPopover]="isActive.endUser"
    icon="far fa-user"
    route="enterprise-users"
  >
    <span>{{ 'menu.users' | portalTranslate }}</span>

    <ng-template>
      <portal-enterprise-end-users-sub-nav [force]="true"></portal-enterprise-end-users-sub-nav>
    </ng-template>
  </portal-main-nav-item>

  @if ((licenses$ | async).callCenter) {
    <portal-main-nav-item
      [showPopover]="isActive.callCenter"
      icon="far fa-database"
      route="enterprise-call-center"
    >
      <span>{{ 'menu.callCenter' | portalTranslate }}</span>
      <ng-template>
        <portal-enterprise-call-center-sub-nav [force]="true"></portal-enterprise-call-center-sub-nav>
      </ng-template>
    </portal-main-nav-item>
  }

  <portal-main-nav-item
    *portalIsAuthorized="{ anyPermission: [Permission.VIEW_ACD] }"
    icon="far fa-compass"
    route="enterprise-acd-queues"
  >
    <span>{{ 'menu.acdQueues' | portalTranslate }}</span>
  </portal-main-nav-item>

  @if ((showTrunks$ | async) == true) {
    <portal-main-nav-item icon="far fa-network-wired" route="enterprise-trunks">
      <span>{{ 'menu.businessTrunks' | portalTranslate }}</span>
    </portal-main-nav-item>
  }

  <portal-main-nav-item
    *portalIsAuthorized="{
      anyPermission: [
        Permission.VIEW_PHONEBOOK,
        Permission.VIEW_ANY_PHONEBOOK,
        Permission.MANAGE_ANY_PHONEBOOK,
      ],
    }"
    icon="far fa-address-book"
    route="enterprise-phone-book"
  >
    <span>{{ 'menu.phonebook' | portalTranslate }}</span>

    <ng-template>
      <portal-enterprise-phone-book-sub-nav [force]="true"></portal-enterprise-phone-book-sub-nav>
    </ng-template>
  </portal-main-nav-item>

  <portal-main-nav-item
    *portalIsAuthorized="{
      allEnterpriseOptions: [EnterpriseOption.CollaborationFeatures],
      anyPermission: [Permission.VIEW_CONFERENCE, Permission.VIEW_ANY_CONFERENCE],
    }"
    icon="far fa-users"
    route="enterprise-meetings"
  >
    <span>{{ 'menu.meetings' | portalTranslate }}</span>
  </portal-main-nav-item>

  @if ((licenses$ | async).conference) {
    <portal-main-nav-item icon="far fa-comments" route="enterprise-conference">
      <span>{{ 'menu.conferences' | portalTranslate }}</span>
    </portal-main-nav-item>
  }

  @if ((licenses$ | async).ivr) {
    <portal-main-nav-item
      *portalIsAuthorized="{
        anyPermission: [Permission.VIEW_IVR, Permission.VIEW_ANY_IVR],
      }"
      icon="far fa-random"
      route="enterprise-ivrs"
    >
      <span>{{ 'menu.ivr' | portalTranslate }}</span>
    </portal-main-nav-item>
  }

  <portal-main-nav-item
    *portalHasEnterpriseOption="EnterpriseOption.ABRoutingService"
    icon="far fa-long-arrow-right"
    route="enterprise-ab-routing"
  >
    <span>{{ 'menu.abRouting' | portalTranslate }}</span>
    <ng-template>
      <portal-enterprise-ab-routing-sub-nav [force]="true"></portal-enterprise-ab-routing-sub-nav>
    </ng-template>
  </portal-main-nav-item>

  <portal-main-nav-item icon="far fa-scroll" route="enterprise-journal">
    <span>{{ 'menu.journal.title' | portalTranslate }}</span>

    <ng-template>
      <portal-enterprise-journal-sub-nav [force]="true"></portal-enterprise-journal-sub-nav>
    </ng-template>
  </portal-main-nav-item>

  <portal-main-nav-item
    *portalIsAuthorized="{ anyPermission: [Permission.VIEW_SOFTCLIENTS] }"
    icon="far fa-download"
    route="enterprise-soft-clients"
  >
    <span>{{ 'menu.softClients' | portalTranslate }}</span>
  </portal-main-nav-item>

  <portal-main-nav-item
    *portalIsAuthorized="{ anyPermission: [Permission.VIEW_DOCUMENTS] }"
    icon="far fa-book"
    route="enterprise-documentation"
  >
    <span>{{ 'menu.documentation' | portalTranslate }}</span>
  </portal-main-nav-item>
</portal-main-nav>
